import React from "react";

export default function Education() {
  return (
    <section className="relative py-5 xl:py-16 px-6  overflow-hidden">
      {/* Grid background */}
      <div className="absolute inset-0" />

      <div className="relative max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-10 xl:mb-20">
          <p
            className="flex justify-center items-center gap-2 text-[16px] font-medium mb-4 text-[#F8F8F8]"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <span className="w-2.5 h-2.5 rounded-full bg-[#86ff9f]" />
            Education & Work
          </p>

          <h2
            className="text-[24px] md:text-[32px] xl:text-[42px] font-semibold leading-[1.2em] text-[#F8F8F8]"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Foundation and growth: my <br />
            <span className="bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent">
              education & work
            </span>
          </h2>
        </div>

        {/* Cards */}
        <div
          className="grid grid-cols-1 lg:grid-cols-2 gap-10"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          {/* Education Card */}
          <div className="group bg-white/5 backdrop-blur-xl rounded-3xl border border-[#ffffff0f] p-4 md:p-10 ">
            <div className="flex items-center gap-4 mb-10">
              <div className="w-14 h-14 rounded-full bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] flex items-center justify-center text-[#0f2e2e] font-bold">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 20 21"
                  fill="none"
                  className="
    transform-gpu
    transition-transform duration-500 ease-in-out
    group-hover:[transform:rotateY(180deg)]
  "
                >
                  <path
                    d="M7.47166 3.23602L8.08595 1.65031C8.18955 1.38183 8.37181 1.1509 8.60888 0.987755C8.84594 0.824614 9.12675 0.736873 9.41452 0.736023H10.5859C10.8737 0.736873 11.1545 0.824614 11.3916 0.987755C11.6287 1.1509 11.8109 1.38183 11.9145 1.65031L12.5288 3.23602L14.6145 4.43602L16.3002 4.17888C16.5809 4.14078 16.8666 4.18699 17.121 4.31163C17.3753 4.43627 17.5869 4.63372 17.7288 4.87888L18.3002 5.87888C18.4467 6.12795 18.5141 6.41557 18.4937 6.70377C18.4733 6.99197 18.366 7.26721 18.1859 7.49317L17.1431 8.82174V11.2217L18.2145 12.5503C18.3946 12.7763 18.5019 13.0515 18.5223 13.3397C18.5427 13.6279 18.4752 13.9155 18.3288 14.1646L17.7574 15.1646C17.6155 15.4098 17.4039 15.6072 17.1495 15.7318C16.8952 15.8565 16.6095 15.9027 16.3288 15.8646L14.6431 15.6075L12.5574 16.8075L11.9431 18.3932C11.8395 18.6616 11.6572 18.8926 11.4202 19.0557C11.1831 19.2189 10.9023 19.3066 10.6145 19.3075H9.41452C9.12675 19.3066 8.84594 19.2189 8.60888 19.0557C8.37181 18.8926 8.18955 18.6616 8.08595 18.3932L7.47166 16.8075L5.38595 15.6075L3.70023 15.8646C3.41954 15.9027 3.13386 15.8565 2.87949 15.7318C2.62513 15.6072 2.41355 15.4098 2.27166 15.1646L1.70023 14.1646C1.55381 13.9155 1.48634 13.6279 1.50675 13.3397C1.52715 13.0515 1.63446 12.7763 1.81452 12.5503L2.85738 11.2217V8.82174L1.78595 7.49317C1.60589 7.26721 1.49858 6.99197 1.47818 6.70377C1.45777 6.41557 1.52524 6.12795 1.67166 5.87888L2.24309 4.87888C2.38498 4.63372 2.59655 4.43627 2.85092 4.31163C3.10529 4.18699 3.39097 4.14078 3.67166 4.17888L5.35738 4.43602L7.47166 3.23602Z"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M10.0001 14.3075C12.367 14.3075 14.2858 12.3887 14.2858 10.0217C14.2858 7.6548 12.367 5.73602 10.0001 5.73602C7.63313 5.73602 5.71436 7.6548 5.71436 10.0217C5.71436 12.3887 7.63313 14.3075 10.0001 14.3075Z"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M10 5.73602V10.0217H14.2857"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M10.0003 10.0217L6.97168 13.0503"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="text-[16px] md:text-[18px] xl:text-[20px] leading-[1.2em] font-semibold text-[#F8F8F8]">
                Education
              </h3>
            </div>

            <div className="space-y-8">
              {[
                {
                  title: "JNTUK University",
                  sub: "B.Tech in Agricultural Engineering",
                  year: "2018 - 2022",
                },
                {
                  title: "Sri Chaitanya Junior College",
                  sub: "Intermediate (MPC)",
                  year: "2016 - 2018",
                },
                {
                  title:
                    "Mahatma Jyothiba Phule BC Welfare AP Residential Schoo",
                  sub: "High School",
                  year: "2010 - 2016",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between gap-5"
                >
                  <div>
                    <h4 className="text-[18px] xl:text-[20px] leading-[1.2em] font-semibold text-[#F8F8F8] py-1">
                      {item.title}
                    </h4>
                    <p className="text-[#F8F8F8] text-[14px] md:text-[16px] font-normal leading-[1.4em]">
                      {item.sub}
                    </p>
                  </div>
                  <span className="px-5 py-2 rounded-full bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] text-[#163031] text-[14px] font-semibold whitespace-nowrap leading-[1.6em]">
                    {item.year}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Work Experience Card */}
          <div className="group bg-white/5 backdrop-blur-xl rounded-3xl border border-[#ffffff0f] p-4 md:p-10 ">
            <div className="flex items-center gap-4 mb-10">
              <div className="w-14 h-14 rounded-full bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] flex items-center justify-center text-[#0f2e2e]  font-bold">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 21 21"
                  fill="none"
                  className="
    transform-gpu
    transition-transform duration-500 ease-in-out
    group-hover:[transform:rotateY(180deg)]
  "
                >
                  <path
                    d="M8.35721 1.45032H1.21436V8.59317H8.35721V1.45032Z"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M19.4285 19.3074H12.2856"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M12.2856 12.1646H19.4285"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M12.2856 15.736H19.4285"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M19.7859 8.59317H11.9287L15.8573 0.736023L19.7859 8.59317Z"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M4.78578 19.3075C6.75823 19.3075 8.35721 17.7085 8.35721 15.736C8.35721 13.7636 6.75823 12.1646 4.78578 12.1646C2.81334 12.1646 1.21436 13.7636 1.21436 15.736C1.21436 17.7085 2.81334 19.3075 4.78578 19.3075Z"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="text-[16px] md:text-[18px] xl:text-[20px] leading-[1.2em] font-semibold text-[#F8F8F8]">
                Work experience
              </h3>
            </div>

            <div className="space-y-8">
              {[
                {
                  title: "NovaTales Media LLP",
                  sub: "Senior Web Developer",
                  year: "2023 - PRESENT",
                },
                {
                  title: "SS Labs",
                  sub: "Intern Web Developer",
                  year: "2022 - 2023",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between gap-6"
                >
                  <div>
                    <h4 className="text-[18px] xl:text-[20px] leading-[1.2em] font-semibold text-[#F8F8F8] py-1">
                      {item.title}
                    </h4>
                    <p className="text-[#F8F8F8] text-[14px] md:text-[16px] font-normal leading-[1.4em] ">
                      {item.sub}
                    </p>
                  </div>

                  <span className="px-5 py-2 rounded-full bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] text-[#163031] text-[14px] font-semibold whitespace-nowrap leading-[1.6em]">
                    {item.year}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
